﻿import { Component} from '@angular/core';
import { Tabla} from '../../_components/tabla';

@Component({ templateUrl: 'parametros.component.html' })
export class RootParametrosComponent {

    data: any;

    tabla: Tabla = {
        titulo: 'Par&aacute;metros',
        hideHeader: false,
        hideFilter: false,
        externalData: false,
        endPoint: '/rest-api/root/param',
        editable: true,
        nuevo: true,
        columnas: [
            {
                name: 'ID',
                prop: 'id',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 75
            },
            {
                name: 'Clave',
                prop: 'clave',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 250
            },
            {
                name: 'Valor',
                prop: 'valor',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 250
            },
            {
                name: 'Publico',
                prop: 'publico',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 100
            }
        ]
    };

    constructor() {}

}
